// Per-workspace UI preferences persisted in localStorage.
//
// These are presentation-only choices (a dismissed guide, a hidden nudge) that
// belong to one workspace on one browser — deliberately NOT server state, so a
// user hiding a panel in their own session never changes what teammates see.
// Every access is wrapped: localStorage throws in private-browsing / blocked-
// cookie contexts, and a hidden panel is never worth crashing a page over.

export const lsKey = (base, wsId) => `${base}:${wsId}`;

export const lsRead = (base, wsId) => {
  try {
    return localStorage.getItem(lsKey(base, wsId)) === "true";
  } catch (_) {
    return false;
  }
};

export const lsWrite = (base, wsId, val) => {
  try {
    localStorage.setItem(lsKey(base, wsId), String(val));
  } catch (_) {
    /* localStorage unavailable — fall back to in-memory state only */
  }
};

export const lsReadArr = (base, wsId) => {
  try {
    const raw = localStorage.getItem(lsKey(base, wsId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (_) {
    return [];
  }
};

export const lsWriteArr = (base, wsId, arr) => {
  try {
    localStorage.setItem(lsKey(base, wsId), JSON.stringify(arr));
  } catch (_) {
    /* localStorage unavailable — fall back to in-memory state only */
  }
};
